import React, {useContext, useEffect, useState} from 'react';
import {loadStripe} from "@stripe/stripe-js/pure";
import {Elements} from "@stripe/react-stripe-js";

const StripeContext = React.createContext();

export function StripeProvider ({ children }) {
  const [clientSecret, setClientSecret] = useState(null);
  const [accountId, setAccountId] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  function initStripe(_clientSecret=null, _accountId=null){
    let options = {
      apiVersion: "2022-11-15"
    };
    if (_accountId){
      options.stripeAccount = _accountId;
    }

    return new Promise((resolve, reject) => {
      try {
        const _stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK, options);
        // After Stripe is loaded, save stripePromise to state and the client secret.
        _stripePromise.then(() => {
          setStripePromise(_stripePromise);
          setClientSecret(_clientSecret);
          setAccountId(_accountId);
          resolve(_stripePromise);
        });
      } catch (err) {
        reject(err);
      }
    })
  }

  return (
      <StripeContext.Provider value={{
        stripePromise,
        clientSecret,
        accountId,
        initStripe,
      }}><Elements stripe={stripePromise} options={{clientSecret: clientSecret}}>
        { children }
      </Elements>
      </StripeContext.Provider>
  );
}

export function useStripePayments () {
  const {
    stripePromise,
    clientSecret,
    accountId,
    initStripe,

    ...context
  } = useContext(StripeContext);
  if (context === undefined) {
    throw new Error(`useStripePayments must be used within a StripeProvider`);
  }

  return {
    stripePromise,
    clientSecret,
    accountId,
    initStripe,
  };
}
